export default __webpack_public_path__ + "static/media/ServiceLandingPage.6ef7c4cd.jpeg";